import React from 'react'
import logo from '../../assets/Sidebar-logo.png'
import styled from 'styled-components';
import { FlxCenter } from '../../styles/globalStyles';
import {AccountData, AdminData, MyData} from './SidebarData';
import {TextContainer } from '../../styles/globalStyles';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLES } from '../FoodAppConstants';
import { sideBarOff } from '../../redux/feature/uiSlice';
import {Cross as Cancel } from '@styled-icons/entypo/Cross'
import {b} from '../../styles/variables'
import { useDispatch } from 'react-redux';

function Sidebar() {
const cart = useSelector(state=>state.cart)
const auth=useSelector((state) => state.auth)
const {sidebarState} = useSelector((state) => state.ui);
const dispatch = useDispatch()

  return (
    <MainContainer>  
    <CancelWrapper><CancelIcon size={28} onClick={()=>{dispatch(sideBarOff())}}/></CancelWrapper>   
    <LogoContainer>
    <Logo src={logo} /> 
    <AppTitle>Food Ordering</AppTitle>
    </LogoContainer>
    
    <BodyContainer>
      <SectionHeader>Menu</SectionHeader>
    <RoutesContainer>
    <ULContainer>
    {MyData.map((item, index) => {
              return (
                <LIContainer key={index}>
                  <StyledNavLink to={item.path} end={item.path === "/"}>
                    <RouteContainer>
                      <IconContainer>{item.icon}</IconContainer>
                    <span>{item.title}</span>
                    {item.title==="Cart" && cart.cartTotalQuantity > 0 && <CartBadge>{cart.cartTotalQuantity}</CartBadge>}
                    </RouteContainer>
                  </StyledNavLink>
                </LIContainer>
              );
            })}
      </ULContainer>
    </RoutesContainer>

   {(auth?.creds?.roleslist?.includes(ROLES['Admin']) || auth?.creds?.roleslist?.includes(ROLES['AdminRead'])) && <>
    <SectionHeader>Live Orders</SectionHeader>
    <RoutesContainer>
    <ULContainer>
    {AdminData.map((item, index) => {
              return (
                <LIContainer key={index}>
                  <StyledNavLink to={item.path}>
                    <RouteContainer>
                      <IconContainer>{item.icon}</IconContainer>
                    <span>{item.title}</span>
                    </RouteContainer>
                  </StyledNavLink>
                </LIContainer>
              );
            })}
      </ULContainer>
    </RoutesContainer> </>} 

    {auth?.creds?.roleslist?.includes(ROLES['Finance']) && <>
    <SectionHeader>Accounts</SectionHeader>
    <RoutesContainer>
    <ULContainer>
    {AccountData.map((item, index) => {
              return (
                <LIContainer key={index}>
                  <StyledNavLink to={item.path}>
                    <RouteContainer>
                      <IconContainer>{item.icon}</IconContainer>
                    <span>{item.title}</span>
                    </RouteContainer>
                  </StyledNavLink>
                </LIContainer>
              );
            })}
      </ULContainer>
    </RoutesContainer>  </>}
    </BodyContainer>
    <FooterContainer>
      <FooterText>Freespace Food App</FooterText>
    </FooterContainer>
    </MainContainer>
  )
};

export default Sidebar;

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #a1a1aa;
  overflow-y: auto;
`

const CancelWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0.8rem;

  @media ${b.desktop}{
    display: none;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 1rem;
`

const Logo = styled.img`
  width: 130px;
  height: auto;
  cursor: pointer;
  margin-bottom: 0.6rem;
  opacity: 0.9;
`

const AppTitle = styled.span`
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 300;
  letter-spacing: 0.5px;
`

const CancelIcon = styled(Cancel)`
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.2s ease;
  padding: 8px;
  min-width: 44px;
  min-height: 44px;

  &:hover, &:active { 
    cursor: pointer;
    color: #F7707D;
  }
`

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 1.2rem;
`

const SectionHeader = styled.div`
  color: rgba(255, 255, 255, 0.35);
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 0.8rem;
  margin-top: 1.2rem;
  padding-left: 1rem;
`

const FooterContainer = styled.div`
  display: flex;
  padding: 1.5rem;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: auto;
`

const FooterText = styled.span`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.2);
  font-weight: 300;
`

const RoutesContainer = styled.div`
  display: flex;
  width: 100%;    
  cursor: pointer; 
`

const ULContainer = styled.ul`
  width: 100%;
  list-style: none;
`

const LIContainer = styled.li`
  margin-bottom: 2px;
`

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: #a1a1aa;
  display: block;
  padding: 1rem 1rem;
  border-radius: 10px;
  transition: all 0.2s ease;
  font-size: 1.35rem;
  font-weight: 400;
  min-height: 44px;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.08);
  }

  &.active {
    color: #F7707D;
    background: rgba(247, 112, 125, 0.1);
    font-weight: 600;
  }
`

const RouteContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

const CartBadge = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  margin-left: auto;
  font-size: 1.1rem;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 22px;
`
